"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _assign = require("babel-runtime/core-js/object/assign");

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _moment = require("moment");

var _moment2 = _interopRequireDefault(_moment);

var _Button = require("../form/Button");

var _Button2 = _interopRequireDefault(_Button);

var _Spinner = require("../Spinner");

var _Spinner2 = _interopRequireDefault(_Spinner);

var _UserUtil = require("../../utils/UserUtil");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OrderLicenseConfirmPanel = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(OrderLicenseConfirmPanel, _Component);

  function OrderLicenseConfirmPanel() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, OrderLicenseConfirmPanel);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = OrderLicenseConfirmPanel.__proto__ || (0, _getPrototypeOf2.default)(OrderLicenseConfirmPanel)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function () {
      var _this$props = _this.props,
          user = _this$props.user,
          orderLicense = _this$props.orderLicense,
          values = _this$props.values;


      if (_this.isCompanyUser()) {
        // values.business_id=user.tempData.business_id;
        var data = (0, _assign2.default)({}, user, values);
        orderLicense(user.id, data);
      } else {
        // API  Paytrail..
        // ref .redux -> orderLicense
        event.preventDefault();
        user.company_id = "";

        // user.company_id = user.company_id == null ? '000000' : user.company_id;
        user.price = "120";
        values.postal_area = user.address.postal_area;
        values.postal_code = user.address.postal_code;
        values.address = user.address.street_address;

        var payload = _this.createOrderBody("WEB_PAYMENT");
        _this.props.placeWebOrder(payload);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(OrderLicenseConfirmPanel, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _props = this.props,
          orderLicense = _props.orderLicense,
          user = _props.user,
          values = _props.values;


      if (user.tempData) {
        values.address = user.tempData.address;
        values.company_address = user.tempData.address;
        values.company_name = user.tempData.company_name;
        values.company_postal_area = user.tempData.postal_area;
        values.company_postal_code = user.tempData.postal_code;
        values.order_reference = user.tempData.order_reference;
        values.postal_area = user.tempData.postal_area;
        values.postal_code = user.tempData.postal_code;
        values.profile = user.tempData.profile;

        if (this.isCompanyUser()) {
          values.business_id = user.tempData.business_id;

          var data = (0, _assign2.default)({}, user, values);
        } else {
          // here API call for Paytrail..
          // redux -> orderLicense
          values.business_id = "NOT_IN_USE";
          user.company_id = "";

          var payload = this.createOrderBody("WEB_PAYMENT");
          this.props.placeWebOrder(payload);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var orderLicenseLoading = this.props.license.orderLicenseLoading;
      var _props2 = this.props,
          orderLicense = _props2.orderLicense,
          user = _props2.user,
          values = _props2.values;

      // This portion works when New Registration made

      if (user.tempData) {
        return _react2.default.createElement(
          "div",
          { className: "row" },
          "Luodaan profiilia..."
        );
      }

      return _react2.default.createElement(
        "div",
        { className: "row" },
        _react2.default.createElement(
          "div",
          { className: "col col-xs-12" },
          _react2.default.createElement(
            "button",
            {
              className: "confirmation-button-back back-button-js",
              onClick: this.props.formPage
            },
            "Takaisin"
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "col col-xs-12" },
          _react2.default.createElement(
            "h1",
            { className: "h3" },
            "Tilausvahvistus"
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "col col-xs-12" },
          _react2.default.createElement(
            "h3",
            { className: "h5 order-license-title" },
            _react2.default.createElement("i", { className: "icon-mp-ok" }),
            "K\xE4ytt\xF6lisenssi"
          ),
          this.renderLicenseInfo(),
          _react2.default.createElement(
            "p",
            null,
            _react2.default.createElement(
              "b",
              null,
              "Hinta: ",
              this.renderPrice()
            ),
            _react2.default.createElement("br", null),
            _react2.default.createElement(
              "b",
              null,
              "Voimassa:"
            ),
            " ",
            (0, _moment2.default)().add(6, "month").format("D.M.YYYY"),
            " ",
            "saakka"
          ),
          _react2.default.createElement(
            "div",
            { className: "row" },
            _react2.default.createElement(
              "div",
              { className: "col col-xs-12 col-sm-6" },
              _react2.default.createElement(
                "h3",
                { className: "h4" },
                "Laskutustiedot"
              ),
              this.renderInvoicingInfo()
            ),
            _react2.default.createElement(
              "div",
              { className: "col col-xs-12" },
              this.renderError(),
              _react2.default.createElement(
                _Button2.default,
                {
                  text: "Tilaa",
                  additionalClasses: "button-set-width button-submit submit-js",
                  disabled: orderLicenseLoading,
                  onClick: this.handleClick
                },
                this.renderSpinner()
              )
            )
          )
        )
      );
    }
  }, {
    key: "renderLicenseInfo",
    value: function renderLicenseInfo() {
      var text = "Voit nähdä tarjouspyyntöjen ja maa aineksien tarjoajien yhteystiedot 6 kuukauden ajan.";
      if (this.isCompanyUser()) {
        text += " Lisäksi saat käyttöoikeuden Maapörssin kuljettajasovellukseen.";
      }
      return _react2.default.createElement(
        "p",
        { className: "license-info-js" },
        _react2.default.createElement(
          "i",
          null,
          text
        )
      );
    }
  }, {
    key: "renderPrice",
    value: function renderPrice() {
      if (this.isCompanyUser()) {
        return "225 € (282,40 € sis. alv. 25.5%) / 6 kk";
      }
      return "120 € (150,60 € sis. alv. 25.5%) / 6 kk";
    }
  }, {
    key: "renderInvoicingInfo",
    value: function renderInvoicingInfo() {
      var _props3 = this.props,
          user = _props3.user,
          values = _props3.values;

      if (this.isCompanyUser()) {
        return _react2.default.createElement(
          "p",
          { className: "company-info-js" },
          _react2.default.createElement(
            "b",
            null,
            "Tunnus:"
          ),
          " ",
          user.email,
          _react2.default.createElement("br", null),
          _react2.default.createElement(
            "b",
            null,
            "Yritys:"
          ),
          " ",
          values.company_name,
          _react2.default.createElement("br", null),
          _react2.default.createElement(
            "b",
            null,
            "Y-tunnus:"
          ),
          " ",
          values.business_id,
          _react2.default.createElement("br", null),
          _react2.default.createElement(
            "b",
            null,
            "Nimi:"
          ),
          " ",
          user.first_name,
          " ",
          user.last_name,
          _react2.default.createElement("br", null),
          _react2.default.createElement(
            "b",
            null,
            "Osoite:"
          ),
          " ",
          (0, _UserUtil.formatAddress)(values.address, values.postal_code, values.postal_area),
          _react2.default.createElement("br", null),
          _react2.default.createElement(
            "b",
            null,
            "Puhelinnumero:"
          ),
          " ",
          user.phone,
          _react2.default.createElement("br", null),
          _react2.default.createElement(
            "b",
            null,
            "Tilausviite:"
          ),
          " ",
          values.order_reference
        );
      } else {
        return _react2.default.createElement(
          "p",
          { className: "user-info-js" },
          _react2.default.createElement(
            "b",
            null,
            "Tunnus:"
          ),
          " ",
          user.email,
          _react2.default.createElement("br", null),
          _react2.default.createElement(
            "b",
            null,
            "Nimi:"
          ),
          " ",
          user.first_name,
          " ",
          user.last_name,
          _react2.default.createElement("br", null),
          _react2.default.createElement(
            "b",
            null,
            "Osoite:"
          ),
          " ",
          (0, _UserUtil.formatAddress)(values.address, values.postal_code, values.postal_area),
          _react2.default.createElement("br", null),
          _react2.default.createElement(
            "b",
            null,
            "Puhelinnumero:"
          ),
          " ",
          user.phone
        );
      }
    }
  }, {
    key: "renderError",
    value: function renderError() {
      var orderLicenseError = this.props.license.orderLicenseError;

      if (orderLicenseError) {
        return _react2.default.createElement(
          "p",
          { className: "error-message error-js" },
          "Tilauksen aikana tapahtui virhe. Yrit\xE4 my\xF6hemmin uudelleen tai ota yhteytt\xE4 Maap\xF6rssiin."
        );
      }
    }
  }, {
    key: "renderSpinner",
    value: function renderSpinner() {
      var orderLicenseLoading = this.props.license.orderLicenseLoading;

      if (orderLicenseLoading) {
        return _react2.default.createElement(_Spinner2.default, { additionalClasses: "mp-spinner-submit spinner-js" });
      }
    }

    // @@THIS CLICKS TO API CALL TO THE pAYTRAIL
    // send data to paytrail

  }, {
    key: "createOrderBody",
    value: function createOrderBody(payment_method) {
      var _props4 = this.props,
          values = _props4.values,
          user = _props4.user;

      return (0, _extends3.default)({}, values, user, {
        payment_method: payment_method
      });
    }
  }, {
    key: "isCompanyUser",
    value: function isCompanyUser() {
      var profile = this.props.values.profile;

      return profile === "COMPANY";
    }
  }]);
  return OrderLicenseConfirmPanel;
}(_react.Component), _class.propTypes = {
  placeWebOrder: _react.PropTypes.func.isRequired,
  orderLicense: _react.PropTypes.func.isRequired,
  formPage: _react.PropTypes.func.isRequired,
  values: _react.PropTypes.object.isRequired,
  user: _react.PropTypes.object.isRequired,
  license: _react.PropTypes.object.isRequired
}, _temp2);
exports.default = OrderLicenseConfirmPanel;
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/license/OrderLicenseConfirmPanel.js
 ** module id = 1152
 ** module chunks = 0
 **/